export default "__VITE_PUBLIC_ASSET__624f0249__"